export const snowPlowPosistionMapper = {
    top: 'header',
    bottom: 'bottom',
    sticky: 'sticky_nav',
    'sticky-nav': 'sticky_nav',
};
